import { useEffect, useRef, useState } from "react";

interface AnimatedCounterProps {
  value: number;
  interval?: "slow" | "medium" | "fast"; // Make interval optional
}

export const TentangKamiCompoCounter = ({
  value,
  interval,
}: AnimatedCounterProps) => {
  const [count, setCount] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  // Determine default interval based on value
  const actualInterval: "slow" | "medium" | "fast" = interval
    ? interval
    : value < 100
    ? "slow"
    : "medium";

  const delay =
    actualInterval === "fast" ? 0.1 : actualInterval === "medium" ? 13 : 180;

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (count < value) {
      intervalId = setInterval(() => {
        setCount((prevCount) => {
          const nextCount = prevCount + 1;
          if (nextCount >= value) {
            clearInterval(intervalId!);
          }
          return nextCount;
        });
      }, delay);
    }

    return () => clearInterval(intervalId!);
  }, [count, value, delay]);

  useEffect(() => {
    const options = {
      rootMargin: "0px",
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setCount(0);
      }
    }, options);

    const currentSectionRef = sectionRef.current;

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="relative">
      <p className="text-black font-extrabold text-5xl">{count.toString()}</p>
    </div>
  );
};
